import { NativeDateAdapter } from '@angular/material/core';

export class LdmDateAdapter extends NativeDateAdapter {
    override getFirstDayOfWeek(): number {
        return 1;
    }
}